import { Injectable, inject } from '@angular/core';
import { IReferenceTaskModel } from '../model/reference-task.model';
import { ENV_CONFIG, EnvironmentConfig, PageResponse, PageUtil } from '@libs/vc-core-lib';
import { Observable, map } from 'rxjs';
import { IReferenceTaskCriteriaDTO } from '../dto/reference-task.criteria.dto';
import { IReferenceTaskSearchDTO } from '../dto/reference-task.search.dto';
import { Page } from 'vcp-common-ui-lib';
import { HttpClient } from '@angular/common/http';
import { IDocLinkPatchRequestModel } from '../model/doc-link-patch-request.model';
import { IReferenceTaskTableDataDTO } from '../model/reference-task-table-data.model';
import { IDocLinkModel } from '../model/doc-link.model';

@Injectable({
    providedIn: 'root',
})
export class ReferenceTaskService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _referenceTaskPath = 'reference-task';

    public get(id: number): Observable<IReferenceTaskModel> {
        return this._httpClient.get<IReferenceTaskModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/${id}`
        );
    }

    public update(referenceTask: IReferenceTaskModel): Observable<IReferenceTaskModel> {
        return this._httpClient.put<IReferenceTaskModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/${referenceTask.id}`,
            referenceTask
        );
    }

    public save(referenceTask: IReferenceTaskModel): Observable<IReferenceTaskModel> {
        return this._httpClient.post<IReferenceTaskModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}`,
            referenceTask
        );
    }

    public delete(id: number): Observable<void> {
        return this._httpClient.delete<void>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/${id}`
        );
    }

    public pageSearch(referenceTaskSearchDTO: IReferenceTaskSearchDTO): Observable<Page<IReferenceTaskTableDataDTO>> {
        return this._httpClient
            .post<
                PageResponse<IReferenceTaskTableDataDTO>
            >(`${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/page-search`, referenceTaskSearchDTO)
            .pipe(map((response: PageResponse<IReferenceTaskTableDataDTO>) => PageUtil.convertToPage(response)));
    }

    public search(searchDTO: IReferenceTaskCriteriaDTO): Observable<Array<IReferenceTaskTableDataDTO>> {
        return this._httpClient.post<Array<IReferenceTaskTableDataDTO>>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/search`,
            searchDTO
        );
    }

    public list(ids: number[]): Observable<IReferenceTaskModel[]> {
        return this._httpClient.post<IReferenceTaskModel[]>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/list`,
            ids
        );
    }

    public patchReferenceTaskDocLinks(
        referenceTaskId: number,
        patchRequest: IDocLinkPatchRequestModel
    ): Observable<IReferenceTaskModel> {
        return this._httpClient.patch<IReferenceTaskModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/${referenceTaskId}/doc-links`,
            patchRequest
        );
    }

    public validateDocLink(docLink: IDocLinkModel): Observable<IDocLinkModel> {
        return this._httpClient.post<IDocLinkModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._referenceTaskPath}/doc-links/validate`,
            docLink
        );
    }
}
